import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import BottomNav from "@/components/BottomNav";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Workout from "@/pages/Workout";
import FinishWorkout from "@/pages/FinishWorkout";
import Progress from "@/pages/Progress";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

function Loader() {
  return <div className="min-h-screen bg-app flex items-center justify-center text-t3 tracking-widest text-xs">CHARGE1</div>;
}

function Protected({ children, requireOnboarding = true }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarding && (user.goal == null || user.daysPerWeek == null || user.age == null)) return <Navigate to="/onboarding" replace />;
  return children;
}

function Shell() {
  const location = useLocation();
  // Handle Google callback
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/onboarding" element={<Protected requireOnboarding={false}><Onboarding /></Protected>} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/workout" element={<Protected><Workout /></Protected>} />
        <Route path="/session/finish" element={<Protected><FinishWorkout /></Protected>} />
        <Route path="/progress" element={<Protected><Progress /></Protected>} />
        <Route path="/profile" element={<Protected><Profile /></Protected>} />
        <Route path="/admin" element={<Protected requireOnboarding={false}><Admin /></Protected>} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <BottomNav />
      <div style={{ height: 84 }} />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0A0A0A", border: "1px solid #1A1A1A", color: "#fff" } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
